import React, { Suspense, lazy, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./Common/Navbar";
import Footer from "./Common/Footer";

// Lazy load route components for code-splitting
const Home = lazy(() => import("./Pages/Home"));
const Career = lazy(() => import("./Pages/Career"));
const Gallery = lazy(() => import("./Pages/Gallery"));
const About = lazy(() => import("./Pages/About"));
const Contact = lazy(() => import("./Pages/Contact"));
const Login = lazy(() => import("./Pages/Login"));
const Blog = lazy(() => import("./Pages/Blog"));
const ContactUs = lazy(() => import("./Components/Admin/ContactUs"));
const GalleryMedia = lazy(() => import("./Components/Admin/GalleryMedia"));
const Category = lazy(() => import("./Components/Admin/Category"));
const AdminBlog = lazy(() => import("./Components/Admin/Blog"));
const AdminNav = lazy(() => import("./Components/Admin/Navbar"));
const Profile = lazy(() => import("./Components/Admin/profile"));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function Routers() {
  const access = localStorage.getItem("access") || "U"; // Example: "A" for Admin, "U" for User

  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<div style={{ minHeight: "100vh", backgroundColor: "#fff" }} />}>
        <AppContent access={access} />
      </Suspense>
    </Router>
  );
}

function AppContent({ access }) {

  return (
    <>
      {/* Render Navbar and Footer only for non-admin and non-login pages */}
      {/* {localStorage.getItem("access") === "A" ? <AdminNav /> : <Navbar />} */}

      <Routes>
        {/* Public Routes */}
        {localStorage.getItem("access") === "A" ? (
          <>
            <Route
              path="/"
              element={
                <>
                  <AdminNav />
                  <ContactUs />
                </>
              }
            />
            <Route
              path="/Admin/AdminGallery"
              element={
                <>
                  <AdminNav />
                  <GalleryMedia />
                </>
              }
            />
            <Route
              path="/Admin/category"
              element={
                <>
                  <AdminNav />
                  <Category />
                </>
              }
            />
            <Route
              path="/Admin/blog"
              element={
                <>
                  <AdminNav />
                  <AdminBlog />
                </>
              }
            />
            <Route
              path="/profile"
              element={
                <>
                  <AdminNav />
                  <Profile />
                </>
              }
            />
          </>
        ) : (
          <>
            <Route
              path="/"
              element={
                <>
                  <Navbar />
                  <Home />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Career"
              element={
                <>
                  <Navbar />
                  <Career />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Gallery"
              element={
                <>
                  <Navbar />
                  <Gallery />
                  <Footer />
                </>
              }
            />
            <Route
              path="/About"
              element={
                <>
                  <Navbar />
                  <About />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Contact"
              element={
                <>
                  <Navbar />
                  <Contact />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Blog"
              element={
                <>
                  <Navbar />
                  <Blog />
                  <Footer />
                </>
              }
            />
            <Route path="/admin" element={<Login />} />
          </>
        )}
      </Routes>

      {/* Render Footer only for non-admin and non-login pages */}
      {/* {localStorage.getItem("access") !== "A" && <Footer />} */}
    </>
  );
}
